import { render } from "./ManageCourse.vue?vue&type=template&id=3ee9d8fe&scoped=true"
import script from "./ManageCourse.vue?vue&type=script&lang=js"
export * from "./ManageCourse.vue?vue&type=script&lang=js"

import "./course-responsive.css?vue&type=style&index=0&lang=css&external"
import "./ManageCourse.vue?vue&type=style&index=1&id=3ee9d8fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee9d8fe"]])

export default __exports__